import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientesService } from "app/core/services/clientes/clientes.service";

@Component({
  selector: "app-add-local",
  templateUrl: "./add-local.component.html",
  styleUrls: ["./add-local.component.css"],
})
export class AddLocalComponent implements OnInit {
  public myForm: FormGroup;
  public local: any;
  public tipos: any[];
  public tiposPropiedad: any[];
  faTimes=faTimes;
  @Input() clienteId = 0;
  @Input() localId = 0;

  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public formbuild: FormBuilder,
    public activeModal: NgbActiveModal,
    private clientesService: ClientesService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    if (this.localId) {
      this.obtenerLocal();
    }
    let tipos = this.clientesService.obtenerLocalesTipos();
    let tiposPropiedad = this.clientesService.obtenerLocalesTiposPropiedad();

    Promise.all([tipos, tiposPropiedad]).then((result) => {
      this.tipos = result["0"]["results"];
      this.tiposPropiedad = result["1"]["results"];
    });
  }

  obtenerLocal() {
    this.clientesService
      .obtenerLocal(this.localId)
      .then((res) => {
        this.local = res;
        this.setForm(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  initForm() {
    this.myForm = this.formbuild.group({
      gravado_beneficiario: [null, []],
      direccion: [null, []],
      telefono: [null, []],
      valor_comercial: [null, []],
      tipo_local: [null, []],
      tipo_propiedad: [null, []],
      area_terreno: [null, []],
      area_construido: [null, []],
    });
  }

  get f() {
    return this.myForm.controls;
  }

  setForm(item) {
    for (const key in item) {
      if (this.myForm.controls[key]) {
        this.myForm.controls[key].setValue(item[key]);
      }
    }
  }

  onSubmit() {
    if (this.myForm.valid) {
      const data = this.myForm.value;
      data["cliente"] = this.clienteId;

      this.clientesService
        .guardarLocal(this.myForm.value, this.localId)
        .then((res) => {
          this.successEmit.emit();
          this.activeModal.close(false);
        })
        .catch((error) => {
          this.activeModal.close(false);
        });
    }
  }

  compararTipos(tipo1: any, tipo2: any) {
    return tipo1 && tipo2 ? tipo1.id === tipo2 : tipo1 === tipo2;
  }
}
